export default __webpack_public_path__ + "static/td-b4de905dcff2586efe64805c1125a165.svg";